import { List } from "../../@types/list";
import {
  AnsweringClient,
  SearchAllUsersParams,
} from "../../clients/answeringClient";
import { IResellerSearchResult } from "../types";

export interface ResellersControllerDelegate {
  didGetResellers(response: List<IResellerSearchResult>): void;
  genericError(message: string): void;
}

export class ResellersController {
  constructor(
    private delegate: ResellersControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {}

  public async searchResellers(
    accessToken: string,
    params: SearchAllUsersParams
  ) {
    try {
      const response = await this.answeringClient.searchResellers(
        accessToken,
        params
      );
      this.delegate.didGetResellers(response.data);
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        "Ocorreu um erro ao buscar os revendedores.";
      this.delegate.genericError(errorMessage);
    }
  }
}
